<template>
  <!-- 질문27/온라인 신경검사게임 -->
  <v-layout flex-fill column class="survey-type-05">
    <div v-if="loaded === false" class="answer">
      <div class="fs-20 text-center pos-center">
        잠시 후 <span class="primary--text">간단한 게임</span>이 진행됩니다.<br/>
        게임은 약 <span class="primary--text">40초 소요</span>됩니다.<br/>
        반드시 <span class="primary--text">시작 전 튜토리얼</span>을 확인해주세요.<br/>
        <span class="primary--text">집중할 수 있는 곳</span>에서 진행해주세요!
      </div>
    </div>
    <div v-else class="answer">
      <input type="hidden" id="unitDtlQuesNo" :value="gameQuesNo"/>
      <input type="hidden" id="travelApplNo" :value="gameApplNo"/>
      <input type="hidden" id="unitDtlNo" :value="gameDtlNo"/>
      <input type="hidden" id="unitNo" :value="gameUnitNo"/>
      <input type="hidden" id="unitDtlReplyNo" :value="gameReplyNo"/>
      <input type="hidden" id="travelApplStepCd" :value="gameTravelApplStepCd"/>
      <input type="hidden" id="memberStepApplCnt" :value="gameMemberStepApplCnt"/>
      <input type="hidden" id="memberNo" :value="memberNo"/>
      <iframe
          id="iframeForGame"
          :src="iframe.src"
          :style="iframe.style"
          height="100%"
          width="100%"
          frameborder="0"
      ></iframe>
    </div>
  </v-layout>
</template>

<script>
import store from '@/store'
import {mixinAuth} from '@/mixins'

export default {
  mixins: [mixinAuth],
  props: ["surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data() {
    return {
      loaded: false,
      iframe: {
        src: '/user/static/game/1stroop/index.html',
        style: 'position: absolute; left: 0; top: 0; right: 0; bottom: 0;border:none; vertical-align: top'
      },
      gameQuesNo: this.surveyData.unitDtlQuesNo,
      gameApplNo: this.surveyData.travelApplNo,
      gameDtlNo: this.surveyData.unitDtlNo,
      gameUnitNo: this.surveyData.unitNo,
      gameTravelApplStepCd: this.travelApplStepCd,
      gameMemberStepApplCnt: this.memberStepApplCnt,
      gameReplyNo: 0,
      memberNo: 0
    }
  },
  mounted() {
    window.disabledNextStatus = this.disabledNextStatus;
  },
  created() {
    this.memberNo = this.userKey;
    this.$emit('radioChanged', '');
    this.getTravelReplyNoForUnikey();
  },
  methods: {
    disabledNextStatus() {
      this.$emit('disabledNextStatus');
    },
    // goGame(){
    //   this.loaded = true;
    // },
    goGame() {
      this.loaded = !this.loaded
    },
    async getTravelReplyNoForUnikey() {
      console.log("getTravelReplyNoForUnikey in ");
      await store.dispatch('getTravelReplyNoForUnikey', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitNo': this.surveyData.unitNo},
        {'memberNo': this.memberNo},
      ]))
        .then(res => {
          console.log('getTravelReplyNoForUnikey : ', res)
          if (res.success) {
            this.gameReplyNo = res.data;
          } else {
            console.log(res.msg)
            this.gameReplyNo = ''
          }
        })
        .catch(error => {
          console.error(error)
          this.gameReplyNo = ''
        })
        .finally(() => {
        })
    }
  }
}
window.addEventListener("message", function (eve) {
  // console.log(eve.data)
  if (eve.data.params == 'next') {
    window.disabledNextStatus()
  }
});
</script>
